import comp from "./JumpToModal";

export default comp;
